import * as yup from 'yup';
import { validationErrors } from 'src/utils/validation/validationErrors';
import {
  EMAIL,
  LINKEDIN,
  PASSWORD,
  validationRules,
} from 'src/utils/validation/validationRules';

export const expertValidationSchema = yup.object().shape({
  first_name: validationRules.USER_FIRST_NAME.required(
    validationErrors.REQUIRED_FIELD,
  ),
  last_name: validationRules.USER_LAST_NAME.required(
    validationErrors.REQUIRED_FIELD,
  ),
  title: validationRules.USER_TITLE.required(validationErrors.REQUIRED_FIELD),
  company_name: validationRules.USER_COMPANY_NAME.required(
    validationErrors.REQUIRED_FIELD,
  ),
  password: PASSWORD.required(validationErrors.REQUIRED_FIELD),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password')], validationErrors.PASSWORD_CONFIRMATION_MATCH)
    .required(validationErrors.REQUIRED_FIELD),
  linkedin: LINKEDIN.required(validationErrors.REQUIRED_FIELD),
  email: EMAIL.required(validationErrors.REQUIRED_FIELD),
  work_phone: validationRules.PHONE_NUMBER.required(
    validationErrors.REQUIRED_FIELD,
  ),
});
